import { createUserGroup } from './create'
import { readUserGroups } from './readCollection'
import { resourceObject } from './resourceObject'
import { updateUserGroup } from './update'

export const userGroups = {
  create: createUserGroup,
  readCollection: readUserGroups,
  resourceObject,
  update: updateUserGroup,
}
